var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass:
        "d-flex ml-auto layers-header px-2 py-4 align-items-center justify-content-between",
    },
    [
      _c("div", { staticClass: "d-flex align-items-center" }, [
        _c("span", [_vm._v(_vm._s(_vm.title))]),
        _vm._v(" "),
        _setup.isPreviewStep
          ? _c(
              "div",
              { staticClass: "ml-2" },
              [_c(_setup.LayersHeaderListPreview)],
              1
            )
          : _vm._e(),
      ]),
      _vm._v(" "),
      !_setup.isReadonly
        ? _c(
            "div",
            { staticClass: "d-flex align-items-center" },
            [
              _setup.canvasElements && _setup.canvasElements.length
                ? [
                    _c(_setup.CButton, {
                      staticClass: "btn",
                      attrs: {
                        size: "icon",
                        title: "Find in Layers",
                        variant: "light",
                        icon: ["fas", "search"],
                      },
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                          return _setup.emit("open-find-layers")
                        },
                      },
                    }),
                    _vm._v(" "),
                    !_setup.areAllElementsUnSelected &&
                    !_setup.areAllElementsSelected
                      ? _c(
                          "button",
                          {
                            staticClass: "btn btn-link",
                            on: {
                              click: function ($event) {
                                $event.stopPropagation()
                                return _setup.selectAllUnlockedElements.apply(
                                  null,
                                  arguments
                                )
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n                Select unlocked\n            "
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _setup.areAllElementsUnSelected &&
                    !_setup.areAllElementsSelected
                      ? _c(
                          "button",
                          {
                            staticClass: "btn btn-link",
                            on: {
                              click: function ($event) {
                                $event.stopPropagation()
                                return _setup.selectAllElements.apply(
                                  null,
                                  arguments
                                )
                              },
                            },
                          },
                          [_vm._v("\n                Select all\n            ")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _setup.areAllElementsSelected
                      ? _c(
                          "button",
                          {
                            staticClass: "btn btn-link",
                            on: {
                              click: function ($event) {
                                $event.stopPropagation()
                                return _setup.clearSelection.apply(
                                  null,
                                  arguments
                                )
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n                Clear selection\n            "
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", { staticClass: "border mx-2" }),
                  ]
                : _vm._e(),
              _vm._v(" "),
              _setup.bulkToggleElements && _setup.bulkToggleElements.length
                ? [
                    _setup.areAllSelectedElementsUnlocked
                      ? _c(
                          "div",
                          { staticClass: "d-flex align-items-center" },
                          [
                            _setup.areAllSelectedElementsHidden
                              ? _c(_setup.CButton, {
                                  directives: [
                                    {
                                      name: "tippy",
                                      rawName: "v-tippy",
                                      value: {
                                        placement: "top",
                                        interactive: false,
                                      },
                                      expression:
                                        "{ placement: 'top', interactive: false }",
                                    },
                                  ],
                                  attrs: {
                                    "data-testid": "bulk-view",
                                    "data-dd-action-name": `View selected${_setup.bulkActionSuffix}`,
                                    content: "View selected",
                                    size: "icon",
                                    icon: ["far", "eye"],
                                  },
                                  on: {
                                    click: function ($event) {
                                      $event.stopPropagation()
                                      return _setup.toggleAllVisible()
                                    },
                                  },
                                })
                              : _c(_setup.CButton, {
                                  directives: [
                                    {
                                      name: "tippy",
                                      rawName: "v-tippy",
                                      value: {
                                        placement: "top",
                                        interactive: false,
                                      },
                                      expression:
                                        "{ placement: 'top', interactive: false }",
                                    },
                                  ],
                                  attrs: {
                                    "data-testid": "bulk-hide",
                                    "data-dd-action-name": `Hide selected${_setup.bulkActionSuffix}`,
                                    content: "Hide selected",
                                    size: "icon",
                                    icon: ["far", "eye-slash"],
                                  },
                                  on: {
                                    click: function ($event) {
                                      $event.stopPropagation()
                                      return _setup.toggleAllVisible()
                                    },
                                  },
                                }),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "d-flex align-items-center" },
                      [
                        !_setup.areAllSelectedElementsLocked
                          ? _c(_setup.CButton, {
                              directives: [
                                {
                                  name: "tippy",
                                  rawName: "v-tippy",
                                  value: {
                                    placement: "top",
                                    interactive: false,
                                  },
                                  expression:
                                    "{ placement: 'top', interactive: false }",
                                },
                              ],
                              attrs: {
                                "data-testid": "bulk-lock",
                                "data-dd-action-name": `Lock selected${_setup.bulkActionSuffix}`,
                                content: "Lock selected",
                                size: "icon",
                                icon: ["far", "lock"],
                              },
                              on: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                  return _setup.toggleAllLock()
                                },
                              },
                            })
                          : _c(_setup.CButton, {
                              directives: [
                                {
                                  name: "tippy",
                                  rawName: "v-tippy",
                                  value: {
                                    placement: "top",
                                    interactive: false,
                                  },
                                  expression:
                                    "{ placement: 'top', interactive: false }",
                                },
                              ],
                              attrs: {
                                "data-testid": "bulk-unlock",
                                "data-dd-action-name": `Unlock selected${_setup.bulkActionSuffix}`,
                                content: "Unlock selected",
                                size: "icon",
                                icon: ["far", "lock-open"],
                              },
                              on: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                  return _setup.toggleAllLock()
                                },
                              },
                            }),
                      ],
                      1
                    ),
                  ]
                : _vm._e(),
              _vm._v(" "),
              _setup.flags?.isAbleToGroupOrUnGroup &&
              _setup.getActiveLayers &&
              _setup.getActiveLayers.length
                ? _c("div", { staticClass: "divider" })
                : _vm._e(),
              _vm._v(" "),
              _setup.flags?.isAbleToGroupOrUnGroup
                ? [
                    _setup.flags?.showGroups
                      ? _c(
                          "div",
                          { staticClass: "layout-btns-container" },
                          [
                            _setup.showGroupButton
                              ? _c(_setup.CButton, {
                                  directives: [
                                    {
                                      name: "tippy",
                                      rawName: "v-tippy",
                                      value: {
                                        placement: "bottom",
                                        interactive: false,
                                      },
                                      expression:
                                        "{ placement: 'bottom', interactive: false }",
                                    },
                                  ],
                                  attrs: {
                                    "data-dd-action-name": "Create Layout",
                                    content: "Create Layout (Ctrl+L)",
                                    size: "icon",
                                    icon: ["fak", "branch"],
                                  },
                                  on: {
                                    click: function ($event) {
                                      $event.stopPropagation()
                                      return _setup.groupSelectedItems({
                                        isLayout: true,
                                      })
                                    },
                                  },
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _setup.showGroupButton
                              ? _c(_setup.CButton, {
                                  directives: [
                                    {
                                      name: "tippy",
                                      rawName: "v-tippy",
                                      value: {
                                        placement: "bottom",
                                        interactive: false,
                                      },
                                      expression:
                                        "{ placement: 'bottom', interactive: false }",
                                    },
                                  ],
                                  attrs: {
                                    "data-dd-action-name": "Create Group",
                                    content: "Create Group (Ctrl+G)",
                                    size: "icon",
                                    icon: ["far", "layer-group"],
                                  },
                                  on: {
                                    click: function ($event) {
                                      $event.stopPropagation()
                                      return _setup.groupSelectedItems({
                                        isLayout: false,
                                      })
                                    },
                                  },
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _setup.showUnGroupButton
                              ? _c(_setup.CButton, {
                                  directives: [
                                    {
                                      name: "tippy",
                                      rawName: "v-tippy",
                                      value: {
                                        placement: "bottom",
                                        interactive: false,
                                      },
                                      expression:
                                        "{ placement: 'bottom', interactive: false }",
                                    },
                                  ],
                                  attrs: {
                                    "data-dd-action-name": _setup.isLayout
                                      ? "Remove Layout"
                                      : "Remove Group",
                                    content: _setup.isLayout
                                      ? "Remove Layout (Ctrl+Shift+G)"
                                      : "Remove Group (Ctrl+Shift+G)",
                                    size: "icon",
                                    icon: [
                                      "fak",
                                      _setup.isLayout
                                        ? "remove-layout"
                                        : "ungroup",
                                    ],
                                  },
                                  on: {
                                    click: function ($event) {
                                      $event.stopPropagation()
                                      return _setup.unGroupSelectedItems()
                                    },
                                  },
                                })
                              : _vm._e(),
                          ],
                          1
                        )
                      : _c(
                          "div",
                          {
                            directives: [{ name: "tippy", rawName: "v-tippy" }],
                            staticClass: "ml-3 heading-section d-flex",
                            attrs: {
                              content:
                                "Your current plan doesn't include this feature. Please check your upgrade options with our supoport team :)",
                            },
                          },
                          [
                            _setup.showGroupButton
                              ? _c("a", { staticClass: "disabled" }, [
                                  _vm._v("Create Layout"),
                                ])
                              : _vm._e(),
                          ]
                        ),
                  ]
                : _vm._e(),
              _vm._v(" "),
              _setup.areAllElementsUnSelected &&
              _setup.flags?.enableImportLayers
                ? _c(_setup.CDropdown, {
                    attrs: {
                      label: "Import",
                      variant: "empty",
                      items: _setup.importFromOptions,
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "dropdown-menu-item",
                          fn: function ({ thumb, label }) {
                            return [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "d-flex align-items-center w-100 cursor-pointer",
                                },
                                [
                                  thumb
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "d-flex align-items-center mr-2",
                                        },
                                        [
                                          _c(_setup.SvgIcon, {
                                            attrs: { src: thumb },
                                          }),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "w-100" }, [
                                    _vm._v(_vm._s(label)),
                                  ]),
                                ]
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      2795173884
                    ),
                  })
                : _vm._e(),
              _vm._v(" "),
              _c(_setup.ModalImport, {
                attrs: {
                  "is-open": _setup.isModalImportOpen,
                  "pre-selected-tab": _setup.preSelectedTab,
                  "handle-close": _setup.closeModalImport,
                  "handle-open": _setup.openModalImport,
                },
                on: { "import-layers": _setup.importLayers },
              }),
              _vm._v(" "),
              _c("input", {
                attrs: {
                  id: "importFromFile",
                  type: "file",
                  accept: ".psd",
                  value: "upload",
                  hidden: "",
                },
                on: { change: _setup.uploadPsdFile },
              }),
              _vm._v(" "),
              _c("input", {
                attrs: {
                  id: "importAmazonFromFile",
                  type: "file",
                  accept: ".xlsx",
                  value: "upload",
                  hidden: "",
                },
                on: { change: _setup.uploadAmazonFile },
              }),
              _vm._v(" "),
              _c("input", {
                attrs: {
                  id: "importAmazonJsonFromFile",
                  type: "file",
                  accept: ".json",
                  value: "upload",
                  hidden: "",
                },
                on: { change: _setup.uploadAmazonJsonFile },
              }),
            ],
            2
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }